import { cn } from '../../lib/utils';

/**
 * Top-level page section. Owns the vertical rhythm and the anchor id used by
 * the header/footer navigation, so no page has to re-invent either.
 */
export function Section({ id, className, containerClassName, children, ...props }) {
  return (
    <section id={id} className={cn('section-y relative', className)} {...props}>
      <div className={cn('container relative z-10', containerClassName)}>{children}</div>
    </section>
  );
}

/**
 * Eyebrow + title + description block used at the top of every section.
 * Keeps the typographic hierarchy identical across the site.
 */
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'center',
  as: Heading = 'h2',
  className,
}) {
  return (
    <div
      className={cn(
        'mb-12 md:mb-16 max-w-3xl',
        align === 'center' && 'mx-auto text-center',
        className,
      )}
    >
      {eyebrow && (
        <span className="inline-block mb-4 rounded-full border border-line-brand bg-brand/10 px-3.5 py-1 text-xs font-bold uppercase tracking-[0.12em] text-brand">
          {eyebrow}
        </span>
      )}
      <Heading className="text-heading font-bold text-white text-balance">{title}</Heading>
      {description && (
        <p className="mt-4 text-lead text-content-muted text-pretty">{description}</p>
      )}
    </div>
  );
}

export default Section;
